import VueRouter, { NavigationGuard, RouteConfig } from 'vue-router'
import LoginPage from './LoginPage/index.vue'
import RegisterPage from './RegisterPage/index.vue'
import InquiryPage from './InquiryPage/index.vue'
import MainPage from './MainPage/index.vue'
import MainPageOverlay from './MainPage/Overlay/index.vue'
import AboutPage from './AboutPage/index.vue'
import CreditsPage from './CreditsPage/index.vue'
import ProfilePage from './ProfilePage/index.vue'
import LeavePage from './LeavePage/index.vue'
import ErrorPage from './ErrorPage/index.vue'
import PasswordResetPage from './PasswordResetPage/index.vue'
import NewPasswordPage from './NewPasswordPage/index.vue'
import MessagePage from './MessagePage/index.vue'
import WelcomePage from './WelcomePage/index.vue'
import RankingPage from './RankingPage/index.vue'
import TestPage from './TestPage/index.vue'
import AdminMessage from './admin/messages/index.vue'
import Vue, { VueConstructor } from 'vue'

const router = new VueRouter({
  routes: [
    route('login', LoginPage),
    route('register', RegisterPage),
    route('inquiry', InquiryPage),
    route('about', AboutPage),
    route('credits', CreditsPage),
    route('profile', ProfilePage),
    route('leave', LeavePage),
    route('error', ErrorPage),
    route('welcome', WelcomePage),
    route('message', MessagePage),
    route('ranking', RankingPage),
    route('password_reset', PasswordResetPage),
    route('new_password', NewPasswordPage),
    route('admin/messages', AdminMessage),
    route('test', TestPage),
    route('main', undefined, {
      path: '/', components: {
        default: MainPage,
        overlay: MainPageOverlay,
      },
    }),
    // @ts-ignore
    route('present202201', () => import('./Present202201Page/index.vue')),
  ],
})

function route(name: string, component?: VueConstructor<Vue>, overwrite: Partial<RouteConfig> = {}): RouteConfig {
  return {
    name, path: `/${name}`, component,
    // @ts-ignore
    beforeEnter: beforeEnter(component || (overwrite.components as any).default),
    ...overwrite,
  }
}

// I don't know why, beforeRouteEnter hook does not work for me.
function beforeEnter(vc: VueConstructor<Vue>) {
  return (vc as any).beforeEnter as NavigationGuard
}

export { router }
